import { AsyncThunkAction } from "@reduxjs/toolkit";
import { AbortableUnwrappable, AppDispatch } from "../redux/types";

export async function dispatchCancellable<T>(
  outerSignal: AbortSignal,
  dispatchAction: () => AbortableUnwrappable<T>,
): Promise<T | undefined> {
  const promise = dispatchAction();

  if (outerSignal.aborted) {
    promise.abort();
    return undefined;
  }

  const onAbort = () => promise.abort();
  outerSignal.addEventListener("abort", onAbort, { once: true });

  try {
    return await promise.unwrap();
  } catch (err) {
    if (outerSignal.aborted) return undefined;
    throw err;
  } finally {
    outerSignal.removeEventListener("abort", onAbort);
  }
}
